import { IInitialState } from "../Interfaces";
import { CreditorGroup } from "./CreditorGroup";

export const initialState: IInitialState = {
  creditorGroups: {
    data: [],
    isFetching: false,
  },
  creditorGroupDetails: {
    data: CreditorGroup,
    isFetching: false,
  },
  drawer: {
    title: "",
    visible: false,
    isNewCreditorGroup: true,
  },
  selectedCreditors: {
    data: [],
    isFetching: false,
  },
};
